import { ICreateCardPayload } from 'api/mutations/createCard.mutation';

import { CardTab } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/CardTab/CardTab';
import { IActiveTab } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/TabsSection/TabsSection';
import { TabItem } from 'components/DesignSystem/Tabs';

export const tabsArrData: TabItem[] = [
    {
        value: 'cardDetails',
        label: 'Card Details',
    },
];

export const buildCreateCardPayload = (data): ICreateCardPayload => {
    return {
        id: data.id,
        projectId: data.project.id,
        contractId: data.contract.id,
        activityId: data.activityId ? data.activityId.id : null,
        assigneeUserName: data.assignee.value,
        category: data.category.value,
        details: data.details,
        mentionedList: data.mentionedList,
        startDate: data.startDate,
        endDate: data.endDate,
        externalLinks: data.externalLinks,
        status: data.status.name,
        tagList: data.tagList.map((item) => ({ name: item.value })),
        title: data.title,
        relatedCardIds: null,
        type: data.type,
        isImportant: data.isImportant,
        versionId: data.versionId,
    };
};
